/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRequired = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12.977 2v8.213l8.086-5.063 1.04 1.7-8.29 5.191 7.822 4.899-1.04 1.7-7.619-4.771.001 8.131H11v-8.197L3.611 18.43l-1.04-1.7 7.485-4.689-7.954-4.98 1.04-1.701L11 10.279V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgRequired as Required };
